import analytics from "../analytics/analytics.js";
import { chatBotConfigFallback } from "../config/chatBotConfigFallback.js";
import { CHATBOT_FEATURES_URL } from "../config/serviceConfig.js";
let chatbotFeaturesCache = null;
let isFetchingFeatures = false;
let featuresFetchPromise = null;
const fetchChatbotFeatures = async (headers)=>{
    if (null !== chatbotFeaturesCache) return chatbotFeaturesCache;
    if (isFetchingFeatures && null !== featuresFetchPromise) return featuresFetchPromise;
    isFetchingFeatures = true;
    featuresFetchPromise = (async ()=>{
        const isBrowser = 'undefined' != typeof window;
        if (!isBrowser) return chatBotConfigFallback();
        const requestHeaders = {
            Accept: 'application/json',
            ...headers
        };
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), 5000);
        try {
            const response = await fetch(CHATBOT_FEATURES_URL, {
                credentials: 'include',
                headers: requestHeaders,
                signal: controller.signal
            });
            clearTimeout(timeoutId);
            if (response && !response.ok) {
                analytics.log({
                    label: 'fetchChatbotFeatures',
                    message: `Failed to fetch chatbot features: ${response.status}`
                });
                return chatBotConfigFallback();
            }
            const data = await response.json();
            chatbotFeaturesCache = data;
            return data;
        } catch (error) {
            clearTimeout(timeoutId);
            chatbotFeaturesCache = chatBotConfigFallback();
            console.error('Error fetching chatbot features:', error);
            analytics.log({
                label: 'chatbotFeatures',
                message: 'error fetching chatbot features',
                error
            });
            return chatBotConfigFallback();
        } finally{
            isFetchingFeatures = false;
        }
    })();
    return featuresFetchPromise;
};
export { fetchChatbotFeatures };
